import { gql } from '@apollo/client'
import React from 'react'

import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { compliancesClient } from '../../../../utils/apollo/api'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'

const Context = React.createContext([])
const { Provider } = Context
export const useNonComplianceState = () => React.useContext(Context)
export const useNonCompliance = () => useNonComplianceState()?.nonCompliance

const QUERY = gql`
  query NonCompliance($id: ID) {
    nonCompliance(id: $id) {
      id
      place {
        id
        name
        resume
      }
      question {
        id
        name
        category {
          id
          name
        }
        checklist {
          id
          name
        }
      }
      status
      origin
      insertedAt
      updatedAt
      endDate
    }
  }
`

const NonComplianceLoader = ({ children, uncontrolledChildren }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: compliancesClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
    </Provider>
  )
}

export default NonComplianceLoader
